import cn from 'classnames'
import Link from 'components/Link'
import type { Category } from '../types'
import classes from '../CategoryNavCarousel.module.scss'

type CategoryNavPillItemProps = {
  category: Category
  slug?: string
  pathCategory: (slug: string) => string
  onNavClick?: (category: Category) => void
}

export const CategoryNavPillItem = ({
  category,
  slug,
  pathCategory,
  onNavClick,
}: CategoryNavPillItemProps) => (
  <span className={cn('mc-mx-1', classes.navItem)}>
    <Link
      passHref
      tabIndex={0}
      href={pathCategory(category.slug)}
      className={cn(
        classes.navButton,
        'mc-py-2 mc-px-3',
        'mc-corners--sm',
        'mc-text-small mc-text--bold',
        category.slug === slug ? [classes.active, 'mc-theme-light'] : null,
      )}
      onClick={() => onNavClick?.(category)}
    >
      {category.name}
    </Link>
  </span>
)
